"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioButtonGroup = exports.RadioButtonGroupLayout = void 0;
var React = require("react");
var RadioButtonGroup_st_css_1 = require("./RadioButtonGroup.st.css");
var RadioButtonGroupLayout;
(function (RadioButtonGroupLayout) {
    RadioButtonGroupLayout["Horizontal"] = "horizontal";
    RadioButtonGroupLayout["Vertical"] = "vertical";
})(RadioButtonGroupLayout = exports.RadioButtonGroupLayout || (exports.RadioButtonGroupLayout = {}));
/** radio button group */
var RadioButtonGroup = /** @class */ (function (_super) {
    __extends(RadioButtonGroup, _super);
    function RadioButtonGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RadioButtonGroup.prototype.render = function () {
        var _this = this;
        var _a = this.props, label = _a.label, layout = _a.layout, error = _a.error, disabled = _a.disabled, errorText = _a.errorText, className = _a.className, theme = _a.theme, withSpacing = _a.withSpacing;
        return (React.createElement("fieldset", { "data-hook": this.props['data-hook'], className: RadioButtonGroup_st_css_1.st(RadioButtonGroup_st_css_1.classes.root, { layout: layout, disabled: disabled, withSpacing: withSpacing }, className) },
            !!label && React.createElement("legend", { className: RadioButtonGroup_st_css_1.classes.label }, label),
            React.createElement("div", { className: RadioButtonGroup_st_css_1.classes.wrapper }, React.Children.map(this.props.children, function (child, idx) {
                if (!React.isValidElement(child)) {
                    return null;
                }
                return (React.createElement(React.Fragment, null, React.cloneElement(child, {
                    key: idx,
                    disabled: disabled,
                    error: error,
                    theme: theme,
                    checked: child.props.value === _this.props.value,
                    onChange: function (e) {
                        _this.props.onChange(e.value);
                    },
                })));
            })),
            !!errorText && !disabled && (React.createElement("span", { className: RadioButtonGroup_st_css_1.classes.error }, errorText))));
    };
    RadioButtonGroup.displayName = 'RadioButtonGroup';
    RadioButtonGroup.defaultProps = {
        value: '',
        layout: RadioButtonGroupLayout.Vertical,
    };
    return RadioButtonGroup;
}(React.Component));
exports.RadioButtonGroup = RadioButtonGroup;
//# sourceMappingURL=RadioButtonGroup.js.map